import { useQuery } from '@tanstack/react-query';
import TokenManager from '../utils/tokenManager';
import { useApiClient } from './useApiClient';

interface User {
  ownerId: string;
  email: string;
  firstName: string;
  lastName: string;
  status: string;
  tier: string;
  createdAt: string;
  entityType: string;
}

export const useUser = () => {
  const tokenManager = TokenManager.getInstance();
  const isAuthenticated = tokenManager.isAuthenticated();
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['user'],
    queryFn: async (): Promise<User> => {
      const response = await apiClient.get('/user');

      if (!response.ok) {
        throw new Error('Failed to fetch user');
      }

      return response.json();
    },
    enabled: isAuthenticated,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};